import { format, parseISO } from 'date-fns';

/** Strip a stored due date to `YYYY-MM-DD` (avoids UTC midnight → local previous-day shifts). */
export function calendarDateOnly(value) {
  return String(value ?? '').slice(0, 10);
}

/** Format a schedule due date for display. Input may be date-only or full ISO. */
export function formatScheduleDate(value, pattern = 'EEE, MMM d, yyyy') {
  const ymd = calendarDateOnly(value);
  if (!ymd || ymd.length < 10) return '—';
  return format(parseISO(ymd), pattern);
}
